module.exports = __webpack_public_path__ + "media/new_message.fcda9709.mp3";